import { Link } from 'react-router';
import Image from '../../../components/image/Image';
import { formatNumber, pluralize } from '../../../utils';
import { useAntallBosser } from './tva-motivational-banner-hooks';
import styles from './tva-motivational-banner.module.less';
import { useProject } from '../../../project/project-hooks/useProject';

const InnsamletBelopMotivasjon = ({ innsamletTotalt, innsamletPerInnbygger, municipality }) => {
    if (innsamletPerInnbygger < 0.02) {
        return (
            <span>
                <strong>Kr {formatNumber(innsamletTotalt, true)}</strong> <em>samlet inn i {municipality}</em>
            </span>
        );
    }
    return (
        <span>
            <strong>Kr {formatNumber(innsamletPerInnbygger, true)}</strong> <em>bidrag per innbygger</em>
        </span>
    );
};

export const TvaMotivationalBanner = () => {
    const project = useProject();
    const municipality = project.location?.municipality_name;
    const county = project.location?.county_name;

    const { isLoading, hasFailed, antallBosser, innsamletPerPerson, innsamletTotalt } = useAntallBosser({
        municipality,
        county,
    });
    if (project.owner?.type === 'org' || !municipality || isLoading || hasFailed) {
        return null;
    }

    const ownerName = project?.profile?.overrideOwnerName || project.owner?.name;

    const antallAndreBosser = antallBosser - 1;
    return (
        <section className={styles.bannerContainer}>
            <div className={styles.bidragPerInnbyggerContainer}>
                <div className={styles.imageContent}>
                    <Image
                        className={styles.imageBosse}
                        src={'campaign/tva2021/bosse.svg'}
                        alt={'Et bilde av en pengebøsse'}
                    />
                </div>
                <div>
                    <Link
                        to={`/bosser/${encodeURIComponent(county)}/${encodeURIComponent(municipality)}`}
                        className={styles.stedsnavn}
                    >
                        {municipality}
                    </Link>
                    <div className={styles.belopTekst}>
                        <Image
                            className={styles.imageBosseInline}
                            src={'campaign/tva2021/bosse.svg'}
                            alt={'Et bilde av en pengebøsse'}
                        />
                        <InnsamletBelopMotivasjon
                            innsamletPerInnbygger={innsamletPerPerson}
                            innsamletTotalt={innsamletTotalt}
                            municipality={municipality}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.takketekstContainer}>
                <p className={styles.takkeTekst}>
                    Tusen takk til {ownerName}{' '}
                    {antallAndreBosser > 0
                        ? `og ${antallAndreBosser} ${pluralize(antallAndreBosser, 'annen', 'andre')}`
                        : ''}{' '}
                    i {municipality} som bidrar til TV-aksjonen med{' '}
                    {pluralize(antallBosser, 'digital bøsse', 'digitale bøsser')} ❤️
                </p>
                <Link to="/bosser">Sjekk ut alle digitale bøsser</Link>
            </div>
        </section>
    );
};

export default TvaMotivationalBanner;
